import { Component, inject, input, OnInit, signal } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { ButtonStyle, NgxButtonComponent } from '@digipay/ngx-button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RiskBarComponent } from '../risk-bar/risk-bar.component';
import { FundStatisticsComponent } from '../fund-statistics/fund-statistics.component';
import { takeUntil } from 'rxjs';

import { ImageComponent } from '../../../../../shared/components/image/image.component';
import { BaseComponent } from '../../../../../components/core/components/base/base.component';
import { IFundProfileModel } from '../../../models/fund-profile.model';
import { FundDataService } from '../../../../../components/core/services/fund-data.service';
import { ErrorService } from '../../../../../components/core/services/error.service';
import { InstrumentService } from '../../../../../components/core/services/instrument.service';
import {
  INVESTMENT_LIST_ROUTE,
  OFF_TIME_ERROR_ROUTE,
  PROVIDER_CAPACITY_FULL_ROUTE,
  PURCHASE_ROUTE,
} from '../../../../../data-access/constants/app-routes';
import { EIntrackEventName } from '../../../../../components/core/models/intrack-event-name.enum';
import { InstrumentOfftimeReason } from '../../../../../data-access/enums/instrument-offtime-reason';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { ActivatedRoute, Params } from '@angular/router';
import { ProfileService } from 'libs/applets/wealth/src/lib/components/core/services/profile.service';
import { UserInfoModel } from '../../../../user-profile/models/user-info.model';
import { NgxEventTrackerService } from '@digipay/ngx-event-tracker';
import { DecimalPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-funds-list-item',
  standalone: true,
  imports: [
    PipesModule,
    ImageComponent,
    NgxBadgeModule,
    RiskBarComponent,
    MatTooltipModule,
    NgxButtonComponent,
    FundStatisticsComponent,
    DecimalPipe,
    NgClass,
  ],
  templateUrl: './funds-list-item.component.html',
  styleUrl: './funds-list-item.component.scss',
})
export class FundsListItemComponent extends BaseComponent implements OnInit {
  fund = input.required<IFundProfileModel>();
  ready = input<boolean>(true);

  actionButtons = signal<IActionButton[]>([
    {
      title: 'جزئیات',
      classNames: '',
      id: 'DETAIL_',
      style: 'tinted-on-elevated',
    },
  ]);
  qParams = signal<Params | undefined>(undefined);
  user = signal<UserInfoModel | undefined>(undefined);

  private eventService = inject(NgxEventTrackerService);
  private fundDataService = inject(FundDataService);
  private navigationService = inject(WealthNavigationService);
  private errorService = inject(ErrorService);
  private instrumentService = inject(InstrumentService);
  private activatedRoute = inject(ActivatedRoute);
  private profileService = inject(ProfileService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe((res) => {
      if (res?.success) {
        this.user.set(res.result);
      }
      this.qParams.set(this.activatedRoute.snapshot.queryParams);
      let hasBuyButton = false;
      if (this.fund()?.investmentType == 'ETF' && this.fund()?.symbol !== 'IRT1SKDF0001' && this.fund()?.symbol != 'IRT1VBAZ0001') {
        hasBuyButton = true;
      } else if (
        this.fund()?.investmentType == 'Mutual' &&
        this.fund()?.symbol === '11421'
        // (this.user().phoneNumber === '09127627101' || this.user().phoneNumber === '09127706148')
      ) {
        hasBuyButton = true;
      } else if (this.fund()?.symbol === '11997') {
        hasBuyButton = false;
      } else {
        this.fundDataService.getUserAssets().subscribe((res) => {
          if (res && res.portfolioDetails) {
            const asset = res.portfolioDetails.find((asset) => asset.symbol === this.fund()?.symbol);
            if (asset?.quantity > 0 && this.fund()?.symbol !== 'IRT1SKDF0001') {
              hasBuyButton = true;
            }
          }
        });
      }
      if (hasBuyButton) {
        this.actionButtons().push({
          title: 'سرمایه‌گذاری',
          classNames: 'detail-button',
          id: 'BUY_',
          style: 'fill',
        });
      }
    });
  }

  goToDetail() {
    this.navigationService.navigateWithState([INVESTMENT_LIST_ROUTE, this.fund().symbol], {
      state: {
        referrer: this.qParams()['referrer'],
      },
    });
  }

  goToBuy() {
    this.eventService.sendEvent({
      eventName: EIntrackEventName.BUY_INVESTMENT_SELECT,
      eventData: {
        FundId: this.fund().symbol,
      },
    });

    this.instrumentService
      .isAvailable(this.fund().symbol, 'BUY')
      .pipe(takeUntil(this.destroyObservable))
      .subscribe((res) => {
        if (res.result?.isAvailable) {
          this.navigationService.navigateWithState([PURCHASE_ROUTE, this.fund().symbol], {
            state: {
              type: this.fund().type,
              investmentType: this.fund()?.investmentType,
              referrer: this.qParams()['referrer'],
            },
          });
        } else {
          if (res?.result?.unavailabilityReason == InstrumentOfftimeReason.NOTBUYABLE) {
            this.navigationService.navigate([PROVIDER_CAPACITY_FULL_ROUTE]);
          } else if (res?.result?.unavailabilityReason == InstrumentOfftimeReason.OFFTIME) {
            this.errorService.setParams({
              description: res.result.noticeMessage,
              title: res.result.noticeTitle,
            });
            this.navigationService.navigate([OFF_TIME_ERROR_ROUTE]);
          }
        }
      });
  }
}

interface IActionButton {
  title: string;
  classNames: string;
  id: string;
  style: ButtonStyle;
}
